<template>
  <button-full @click.native="preAddToCart(product)"
               :disabled="isProductDisabled"
               data-testid="addToCart"
               class="add-to-cart flex middle-xs center-xs"
  >
    <i class="material-icons">shopping_cart</i>{{ $t('Add to cart') }}
  </button-full>
</template>

<script>
import { formatProductMessages } from '@vue-storefront/core/filters/product-messages'
import focusClean from 'theme/components/theme/directives/focusClean'
import ButtonFull from 'theme/components/theme/ButtonFull.vue'
import { AddToCart } from '@vue-storefront/core/modules/cart/components/AddToCart'

export default {
  mixins: [AddToCart],
  directives: { focusClean },
  components: { ButtonFull },
  methods: {
    onAfterRemovedVariant () {
      this.$forceUpdate()
    },
    notifyUser (notificationData) {
      this.$store.dispatch('notification/spawnNotification', notificationData, { root: true })
    },
    preAddToCart (product) {
      if (this.disabled) return;

      this.$bus.$emit('modal-hide', `modal-custom-options-${this.product.sku}${this.getCategoryId}`)
      this.$bus.$emit('modal-hide', `modal-search-custom-options-${this.product.sku}`)
      this.addToCart(product);
      this.$forceUpdate();
    }
  },
  computed: {
    isProductDisabled () {
      return this.disabled || formatProductMessages(this.product.errors) !== '' || this.isAddingToCart
    },
    getCategoryId () {
      return this.categoryId ? `-${this.categoryId}` : ''
    }
  },
  beforeMount () {
    this.$bus.$on('product-after-removevariant', this.onAfterRemovedVariant)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-removevariant')
  }
}
</script>
<style scoped>
  .add-to-cart{
    display: flex;
  }

  i{
    margin-right: 5px;
    width: 24px;
    height: 24px;
    overflow: hidden;
  }
</style>
